/**
 * @module
 * @format
 */

import {service} from 'nova';
import {make} from './api.js';
import {COMPILE, SCOPE} from '@acng/frontend-stargazer';
import {UserImageCrop} from './crop.js';
import {UserImageWaiting} from './waiting.js';
import {UserProfileImageChange} from './change.js';

@service
class UserImageUpload {
  [SCOPE] = this;
  change = new UserProfileImageChange();
  crop = new UserImageCrop();
  waiting = make(UserImageWaiting);

  /** @returns {Promise<undefined>} */
  async [COMPILE]() {
    await this.waiting.sync();
  }
}

export {UserImageUpload};
